import React from 'react'
import { QuickActionsSectionProps } from './types'
import {
  PropertySection,
  SectionHeader,
  SectionTitle,
  CollapseIcon,
  SectionContent,
  PropertyGroup,
  Button,
  FlexRow,
} from '../styled'

const QuickActionsSection: React.FC<QuickActionsSectionProps> = ({
  selectedElement,
  isCollapsed,
  onToggleSection,
  onUpdateElement,
  onDeleteElement,
  onAddElement,
}) => {
  const handleDuplicate = () => {
    if (onAddElement) {
      const newElement = {
        ...selectedElement,
        id: Date.now().toString(),
        position: {
          x: selectedElement.position.x + 20,
          y: selectedElement.position.y + 20,
        },
      }
      onAddElement(newElement)
    }
  }

  return (
    <PropertySection>
      <SectionHeader isCollapsed={isCollapsed} onClick={onToggleSection}>
        <SectionTitle>Quick Actions</SectionTitle>
        <CollapseIcon isCollapsed={isCollapsed}>▼</CollapseIcon>
      </SectionHeader>
      <SectionContent isCollapsed={isCollapsed}>
        <PropertyGroup>
          <FlexRow>
            <Button
              style={{ flex: 1, marginRight: '4px' }}
              onClick={() =>
                onUpdateElement(selectedElement.id, { zIndex: 1000 })
              }>
              ↑ Front
            </Button>
            <Button
              style={{ flex: 1, marginLeft: '4px' }}
              onClick={() =>
                onUpdateElement(selectedElement.id, { zIndex: -1000 })
              }>
              ↓ Back
            </Button>
          </FlexRow>
        </PropertyGroup>
        <PropertyGroup>
          <Button onClick={handleDuplicate}>📋 Duplicate</Button>
        </PropertyGroup>
        <PropertyGroup>
          <Button
            variant="danger"
            onClick={() => onDeleteElement(selectedElement.id)}>
            🗑️ Delete Element
          </Button>
        </PropertyGroup>
      </SectionContent>
    </PropertySection>
  )
}

export { QuickActionsSection }
